import React, {Component} from 'react';
import './styles.scss';
import CardHelper from '../../helpers';

class CardView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showActions: props.showActions
    }
    this.showActions = props.showActions;
    this.cover = props.cover;
    this.bookmark = props.bookmark;
    this.badges = props.badges;
    this.showTitles = props.showTitles;
    this.title = props.title;
    this.isRecentActivity = props.isRecentActivity;
    this.onDeleteAction = props.onDeleteAction;
    this.data = props.data;
    this.id = props.id;
  }

  componentWillUpdate(nextProps){
    if(nextProps.showActions !== this.state.showActions){
      this.setState({showActions: nextProps.showActions});
    }
  }

  render() {

    const {provider = '', live_enabled = "0"} = this.data;
    const isTitleEnabled = CardHelper.posterTitleIsEnabled(provider);

    return (
      <div className={'card card-view'}>
        <div className={'card-container'}>
          <div className={'preview-container'}>
            {this.cover !== '' &&
            <div
              className='card-cover'
              style={{ backgroundImage: `url(${this.cover})` }}
            />
            }
            {CardHelper.createProgressBar(this.bookmark)}
            {CardHelper.createBadge(this.badges)}
          </div>
          {CardHelper.createTitle(this.title, isTitleEnabled, live_enabled === "1")}
        </div>
        <div className='card-labels-container'>
          { CardHelper.createFooter( this.isRecentActivity, this.state.showActions)}
        </div>
      </div>
    );
  }
}

export default CardView;



// WEBPACK FOOTER //
// ./src/components/CardNew/cardTypes/CardView/index.js